export default __webpack_public_path__ + "static/media/comida_3.0a6f6ba1.svg";